// extracted by mini-css-extract-plugin
export var buttonMove = "LoginButtons3-module--buttonMove--3oApb";
export var movingButton = "LoginButtons3-module--movingButton--rd7nu";
export var movingButtonSpan = "LoginButtons3-module--movingButtonSpan--FVUQt";
export var redButton = "LoginButtons3-module--redButton--3c3f+";